import { FC } from 'react';
import DashboardActionCard from '../DashboardActionCard/DashboardActionCard';
import Profile from '@/components/ui/icons/new/Dashboard/Profile';
import { Link, useNavigate } from 'react-router-dom';
import Proposal from '@/components/ui/icons/new/Dashboard/Proposal';
import Document from '@/components/ui/icons/new/Dashboard/Document';
import Help from '@/components/ui/icons/new/Dashboard/Help';
import { useIntercom } from 'react-use-intercom';

interface DashboardActionCardsProps {}

const DashboardActionCards: FC<DashboardActionCardsProps> = () => {
	const navigate = useNavigate();
	const { show } = useIntercom();

	return (
		<div className="grid grid-cols-2 gap-4 mt-4">
			<DashboardActionCard
				card={{
					icon: <Profile />,
					onClick: () => navigate('/account'),
					title: 'My Profile',
					description: (
						<p className="text-center text-black">
							If you haven’t already, make sure you click the circular icon at
							the bottom left or
							<Link
								to="/profile"
								className="ml-1 font-bold text-primary hover:text-secondary"
							>
								click here to complete your profile
							</Link>
						</p>
					),
				}}
			/>
			<DashboardActionCard
				card={{
					icon: <Proposal />,
					title: 'Proposals',
					onClick: () => navigate('/solicitations'),
					description: (
						<p className="text-center text-black">
							Click on the proposals icon to start working on a new proposal
						</p>
					),
				}}
			/>
			<DashboardActionCard
				card={{
					icon: <Document />,
					title: 'Documents',
					onClick: () => navigate('/document'),
					description: (
						<p className="text-center text-black">
							Click on the documents icon to see all your organization's
							documents in one place
						</p>
					),
				}}
			/>
			<DashboardActionCard
				card={{
					icon: <Help />,
					title: 'Help',
					onClick: () => show(),
					description: (
						<p className="text-center text-black">
							Click on the icon on the bottom right to access help at any time.
						</p>
					),
				}}
			/>
		</div>
	);
};

export default DashboardActionCards;
